import * as ResizablePrimitive from 'react-resizable-panels';

import { cn } from '@ideoz/ui';

const ResizablePanelGroup = ({
  className,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelGroup>) => (
  <ResizablePrimitive.PanelGroup
    className={cn('flex h-full w-full data-[panel-group-direction=vertical]:flex-col', className)}
    {...props}
  />
);

const ResizablePanel = ResizablePrimitive.Panel;

const ResizableHandle = ({
  withHandle,
  className,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelResizeHandle> & {
  withHandle?: boolean;
}) => (
  <ResizablePrimitive.PanelResizeHandle
    className={cn(
      'group relative flex w-px w-[2px] items-center justify-center bg-gray-200 transition-all duration-150',
      // Hover state - 2px border
      'hover:w-[2px] hover:bg-gray-400',
      // Focus/Active state - 2px with dark grey
      'focus-visible:outline-none focus-visible:w-[2px] focus-visible:bg-gray-300',
      'data-[resize-handle-active]:w-[2px] data-[resize-handle-active]:bg-gray-300',
      // Vertical panel styles
      'data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full',
      'data-[panel-group-direction=vertical]:hover:h-[2px]',
      '[&[data-panel-group-direction=vertical]>div]:rotate-90',
      className
    )}
    {...props}
  >
    {withHandle && (
      <div
        className={cn(
          'z-10 flex px-1 h-10 w-10 items-center justify-center rounded-full border border-gray-300 bg-white shadow-sm transition-all duration-150',
          // Hover state
          'group-hover:border-gray-400 group-hover:bg-gray-50',
          // Focus/Active state
          'group-focus-visible:border-gray-300 group-focus-visible:bg-gray-300',
          'group-data-[resize-handle-active]:border-gray-300 group-data-[resize-handle-active]:bg-gray-300'
        )}
      ></div>
    )}
  </ResizablePrimitive.PanelResizeHandle>
);

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
